// extracted by mini-css-extract-plugin
export var modal = "_tn-0";
export var table = "_tn-1";